(function () {
  const TRACKING_PARAMS = [
    '_gl',
    'gclid',
    'fbclid',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
  ];

  function stripTrackingParams() {
    if (!window.location.search) return;

    const url = new URL(window.location.href);
    let changed = false;
    for (const param of TRACKING_PARAMS) {
      if (url.searchParams.has(param)) {
        url.searchParams.delete(param);
        changed = true;
      }
    }
    if (!changed) return;
    const query = url.searchParams.toString();
    const newUrl = url.pathname + (query ? '?' + query : '') + url.hash;
    window.history.replaceState({}, '', newUrl);
  }

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(stripTrackingParams, { timeout: 2000 });
  } else {
    setTimeout(stripTrackingParams, 1000);
  }
})();
